const am = {
  // Navigation & General
  SearchPublishedLawImplementations:"Search Published Law Implementations",

  All: "ሁሉም",
  Back: "ተመለስ",
  View: "እይ",
  Action: "ድርጊት",
  Cancel: "ሰርዝ",
  Save: "አስቀምጥ",
  SaveChanges: "ለውጦች አስቀምጥ",
  Saving: "በማስቀመጥ ላይ...",
  Submit: "አስገባ",
  Submitting: "በመላክ ላይ...",
  Approve: "አጽድቅ",
  Edit: "አስተካክል",
  Logout: "ውጣ",
  Contact: "ግንኙነት",
  Address: "አድራሻ",
  Email: "ኢሜል",
  
  // Research Types
  Researches: "ምርምር",
  ConductLegalResearch: "የሕግ ምርምር ማካሄድ",
  LegislativeDrafting: "ሕግ ማርቀቅ",
  LegalAdvisory: "የሕግ ምክር",
  LawImplementation: "የሕግ ትግበራ",
  LegalAwarenessCreation: "የሕግ ግንዛቤ መፍጠር",
  LegalTrainingProvision: "የሕግ ስልጠና መስጠት",
  LegalTranslation: "የሕግ ትርጉም",
  ConductLegislativeRequest: "የሕግ ጥያቄ ማካሄድ",
  RequestLegislativeLetterNumber: "የሕግ ጥያቄ ደብዳቤ ቁጥር",
  
  // Requests
  RegisterDirective: "መመሪያ መመዝገብ",
  SectorDirectives: "የሴክተር መመሪያዎች",
  NewRequest: "አዲስ ጥያቄ",
  CreateCommitteeRequest: "ኮሚቴ መቋቋም",
  CreateInternalRequest: "የውስጥ ጥያቄ ማዘጋጀት",
  InternalRequestTopics: "የውስጥ ጥያቄ ርዕሶች",
  CreateNewRequest: "አዲስ ጥያቄ ፍጠር",
  RequestTable: "የጥያቄ ሰንጠረዥ",
  RequestType: "የጥያቄ አይነት",
  RequestDetail: "የጥያቄ ዝርዝር",
  RequestBy: "የጠየቀው",
  WriteHere: "እዚህ ይጻፉ...",
  ApplicationNumber: "የማመልከቻ ቁጥር",
  Name: "ስም",
  SendRequest: "ጥያቄ ላክ",
  SendFeedback: "የፍላጎት ልዩ ጥያቄ ላክ",
  Selected: "ተመርጧል",
  
  // Status
  ProposalSubmitted: "ፕሮፖዛል ቀርቧል",
  Archived: "ተሰንዷል",
  Published: "የታተመ",
  Accepted: "ተቀባይነት አግኝቷል",
  TopicAcceptedByCoordinatorDirector: "ተቀባይነት አግኝቷል (አስተባባሪ/ዳይሬክተር)",
  TopicApprovedByManagement: "ጸድቋል (ማኔጅመንት)",
  ReturnToCoordinator: "ወደ አስተባባሪ መልስ",
  ReturnedToCoordinatorSuccess: "ወደ አስተባባሪው እና ቡድኑ ተመልሷል።",
  NotTeamMemberTitle: "የተገደበ መዳረሻ",
  NotTeamMemberMessage: "እርስዎ የዚህ የምርምር ቡድን አባል አይደሉም።",
  TeamMemberFeedbackOnly: "እርስዎ የዚህ ቡድን አባል እንጂ መሪ አይደሉም። ፋይል መጫን እና እርምጃ መውሰድ የሚችለው የቡድኑ መሪ ብቻ ነው፤ አስተያየትዎን በቀኝ በኩል ባለው ክፍል መጻፍ ይችላሉ።",
  NotYetAccepted: "እስካሁን አልተቀበለም",
  Rejected: "ውድቅ ሆኗል",
  UnderRevision: "እየተከለሰ ነው",
  Approved: "ጸድቋል",
  Recommended: "ይመከራል",
  Submitted: "ቀርቧል",
  DraftSubmitted: "የረቂቅ ጥያቄ",
  CurrentStatus: "የአሁን ሁኔታ",
  Status: "ደረጃ",
  ForwardStatus: "የመቋረጫ ሁኔታ",
  Broadcasted: "ስክሽት ተደርጓል",
  
  // People & Roles
  Researcher: "ተመራማሪ",
  Member: "አባል",
  Members: "አባላት",
  Coordinator: "አስተባባሪ",
  Stakeholder: "ባለድርሻ",
  StakeholderType: "የባለድርሻ አይነት",
  TeamLeader: "የቡድን መሪ",
  TeamList: "የቡድን ዝርዝር",
  IsTeamLeader: "የቡድን መሪ ነው",
  is_team_leader: "የቡድን መሪ",
  
  // Research Related
  RegNumber: "የምዝገባ ቁጥር",
  ResearchTopic: "የምርምር ርዕስ",
  Abstract: "አጭር ማጠቃለያ",
  ResearchDraftSummary: "የምርምር ረቂቅ ጥቅል ሃሳብ",
  NoSummaryAvailable: "ምንም ጥቅል ሃሳብ የለም",
  Summary: "ጥቅል ሃሳብ",
  SummaryWritten: "የጽሁፍ ጥቅል ሃሳብ",
  EditSummary: "ሃሳብ ጥቅል አስተካክል",
  EnterSummaryPlaceholder: "ጥቅል እዚህ ይፃፉ...",
  SummaryOfComments: "የአስተያየት ሃሳብ ጥቅል",
  SummaryOfWrittenComments: "የጽሁፍ አስተያየቶች ጥቅል",
  SummaryUpdatedSuccess: "ሃሳብ ጥቅል በተሳክ ተዘግጓል!",
  FailedToUpdateSummary: "ሃሳብ ጥቅል ማስተካከል አልተቻለም.",
  summary_of_comments: "የአስተያየት ሃሳብ ጥቅል",
  summary_updated_success: "ሃሳብ ጥቅል በተሳክ ተዘግጓል!",
  PreviousVersions: "የቀድሞ ስሪቶች",
  ViewTeam: "ቡድኑን አሳይ",
  
  // Sector Directives
  directives: {
    checking_accuracy_title: "የሴክተር መመሪያ ማጣቀሻ ምርመራ",
    request_title: "የሴክተር መመሪያ ትክክለኛነት ምርመራ ጥያቄ",
    submit_request_desc: "የሴክተር መመሪያዎን ትክክለኛነት ለማረጋገጥ ጥያቄ ያቅርቡ።",
    submit_request_desc_alt: "አስፈላጊ ሰነዶችን እና ዝርዝሮችን በማቅረብ የሴክተር መመሪያዎችን ትክክለኛነት ለማረጋገጥ ጥያቄዎን ያቅርቡ።",
    explanatory_notes_label: "የተገቢነት መግለጫ",
    explanatory_notes_required: "የተገቢነት መግለጫ ያስፈልጋል",
    letter_ref_number_label: "የደብዳቤ ማጣቀሻ ቁጥር",
    letter_ref_number_placeholder: "ለምሳሌ 12345",
    letter_ref_number_required: "የጥያቄ ደብዳቤ ማጣቀሻ ቁጥር ያስፈልጋል",
    letter_required: "የጥያቄ ደብዳቤ ያስፈልጋል",
    file_required: "የመመሪያ ፋይል ያስፈልጋል",
    fill_all_fields: "እባክዎ ሁሉንም አስፈላጊ ቦታዎችን ይሙሉ.",
    request_success: "የሴክተር መመሪያ ጥያቄ በተሳካ ሁኔታ ተልኳል!",
    search_public_register_directives: "የህዝብ መመሪያዎችን ይፈልጉ",
    search_by_ref_num_or_org: "በማጣቀሻ ቁጥር ወይም ድርጅት ይፈልጉ።",
    loading_public_directives: "የህዝብ መመሪያዎችን በመጫን ላይ...",
    no_public_register_directives_yet: "እስካሁን ምንም የህዝብ መመሪያዎች የሉም",
    select_directive_to_view_details: "ዝርዝሮችን ለማየት መመሪያ ይምረጡ",
    request_failed: "የሴክተር መመሪያ ጥያቄ መላክ አልተሳካም።",
    send_request: "ጥያቄ ላክ",
    document_requirements_title: "የሰነድ መስፈርቶች",
    document_requirements_desc: "የሴክተር መመሪያዎችን ትክክለኛነት የመፈተሽ ጥያቄዎን ለማካሄድ ሁሉም አስፈላጊ ሰነዶች እና መረጃዎች መሰጠታቸውን ያረጋግጡ።",
    note_text: "እባክዎ ለሴክተር መመሪያ ትክክለኛነት ማረጋገጫ ሁሉም አስፈላጊ ሰነዶች መጫኑን እና ቦታዎቹ በትክክል መሞላታቸውን ያረጋግጡ።",
    note_subtext: "የጥያቄ ደብዳቤ እና የመመሪያ ፋይል ከማጣቀሻ ቁጥር እና ገላጭ ማስታወሻዎች ጋር መቅረብ አለባቸው።",
  },
  
  // Documents & Files
  RequestLetter: "የጥያቄ ደብዳቤ",
  DirectiveFile: "መመሪያ ፋይል",
  CompletionLetter: "የማበካ ደብዳቤ",
  CompletionLetterFile: "የማበካ ደብዳቤ ፋይል",
  UploadCompletionLetter: "የማበካ ደብዳቤ ሰቅ",
  WrittenComments: "የጽሁፍ አስተያየቶች",
  DraftLawFile: "የረቂቅ ሕግ ፋይል",
  AmendedFile: "የተስተካከለ ፋይል",
  AmendedLegislativeFile: "የተስተካከለ ሕግ ፋይል",
  FeedbackFile: "የአስተያየት ፋይል",
  RespondBackFile: "የመልስ ፋይል",
  ExplanatoryNote: "የተገቢነት መግለጫ",
  
  // Feedback & Responses
  RespondBack: "መልስ ስጥ",
  RespondBackFeedback: "መልስ የሚሰጥ አስተያየት",
  PublicFeedback: "የህዝብ አስተያየት",
  NoFeedbackYet: "ምንም አስተያየት የለም",
  RequestedDocumentDetail: "የተጠየቀ ሰነድ ዝርዝር",
  FailedToRequestAdditionalInformation: "ተጨማሪ መረጃ ጥያቄ ማቅረብ አልተቻለም.",
  
  // Approval & Forwarding
  ForwardToCoordinator: "ለአስተባባሪ ላክ",
  ForwardToDirector: "ለዳይሬክተር ላክ",
  ForwardToProsecutors: "ለዓቃቤያነ ሕግ ላክ",
  BroadcastToPublicWebsite: "የህዝብ ድረገጾች ላይ ስክስት",
  FinalApproveDraftLaw: "የመጨረሻ ረቂቅ ሕግ ይህን ይስቁ",
  
  // Team Management
  SetupTeamMembers: "የቡድን አባላትን አዘጋጅ",
  SelectProsecutor: "ዓቃቤ ሕግ ምረጥ",
  AddSelectedProsecutorToTeam: "የተመረጠውን ዓቃቤ ሕግ ወደ ቡድን ጨምር",
  NoTeamMembersAdded: "ምንም የቡድን አባል አልተጨመረም",
  team_setup: "የቡድን ቅልጠመና",
  ProsecutorAlreadyAdded: "ዚህ ዓቃቤ ሕግ ቀደም ብሎ ወደ ቡድን ተጨምሯል.",
  PleaseAddTeamMemberBeforeForwarding: "ከመቋረጫ በፊት ቢያንስ አንድ የቡድን አባል አክል.",
  CannotRemoveOnlyTeamLeader: "የብቸኛውን የቡድን መሪ ማስወገድ አይቻልም። እባክዎ አዲስ መሪ ይመድቡ ወይም በቀሪ አባላት ውስጥ ይጨምሩ.",
  
  // Draft Law
  DraftLaw: "የረቂቅ ሕግ",
  DraftLawUploaded: "የረቂቅ ሕግ በተሳክ ተጫኝቷል!",
  FailedToUploadDraftLaw: "የረቂቅ ሕግ ሰቅ አልተቻለም.",
  DraftForwardedSuccess: "የረቂቅ ሕግ በተሳክ ተልኗል!",
  FailedToUpdateDraft: "የረቂቅ ሕግ ማስተካከል አልተቻለም.",
  
  // Messages & Notifications
  ForwardedSuccess: "በተሳክ ተልኗል!",
  FeedbackSubmittedSuccess: "አስተያየት በተሳክ ተልኗል!",
  ProposalApprovedSuccess: "መልካም ተዘጋጅቶአል!",
  LegalResearchForwardedSuccess: "የሕግ ምርምር በተሳክ ተልኗል!",
  CannotForwardBeforeEditing: "ከማስተካከል በፊት ማቅረብ አይቻልም.",
  
  // Error Messages
  FailedToUpdateApproval: "ውሳኔ ማዘመን አልተቻለም.",
  FailedToUpdateLegalResearchRequest: "የሕግ ምርምር ጥያቄ ማስተካከል አልተቻለም.",
  
  // UI Elements
  ErrorFetchingDirectiveRequests: "የመመሪያ ጥያቄዎችን ማምጣት ላይ ስህተት ተከስቷል:",
  FailedToFetchDirectiveRequests: "የመመሪያ ጥያቄዎችን ማምጣት አልተቻለም።",
  Note: "ማስታወሻ",
  Remark: "ማስታወሻ",
  DirectorRemark: "የዳይሬክተር ማስታወሻ",
  CoordinatorRemark: "የአስተባባሪ ማስታወሻ",
  DetailHere: "ዝርዝር እዚህ...",
  RegistrarActions: "የማስመዘገቢያ ተግባሮች",
  LetterReferenceNumber: "የደብዳቤ ማጣቀሻ ቁጥር",
  DocumentRequirements: "የሰነድ መስፈርቶች",
  NoDocumentsUploadedYet: "ምንም ሰነዶች እስካሁን አልተጫኑም",
  
  // Research Search
  research: {
    search_title: "የሕግ ምርምር ፍለጋ",
    search_label: "በምዝገባ ቁጥር ፍለጣ",
    search_placeholder: "ቁጥር አስገባ...",
    searching: "በፍለጋ ላይ...",
    search_button: "ፍለጣ",
    results_count: "{{count}} የተገኙ \"{{term}}\"",
    loading_message: "የምርምር ወረቀቶችን በመጫን ላይ...",
    no_results_found: "\"{{term}}\" ለ የተገኙ አልተገኙም",
    no_data_yet: "የምርምር ወረቀቶች እስካሁን የሉም.",
    search_translation_papers_title: "የሕግ ትርጉም ወረቀቶችን ይፈልጉ",
    loading_translation_data: "የትርጉም መረጃ በመጫን ላይ...",
    no_translation_papers_yet: "እስካሁን ምንም የሕግ ትርጉም ወረቀቶች አልቀረቡም",
    select_translation_paper_details: "ዝርዝሮችን ለማየት የትርጉም ወረቀት ይምረጡ",
    search_failed: "ፍለጋው አልተሳካም",
    failed_to_fetch_legal_translation: "የሕግ ትርጉም ጥያቄ ማምጣት አልተቻለም።",
  },
  
  // Version
  previous_version_one: "የቀድሞ ስሪት",
  previous_version_other: "የቀድሞ ስሪቶች",
  
  // Application Status Flow
  submitted: "ቀርቧል",
  coordinator_remark_submitted: "የአስተባባሪ ማስታወሻ ቀርቧል",
  director_remark_submitted: "የዳይሬክተር ማስታወሻ ቀርቧል",
  draft_approved: "የረቂቅ ሕግ ጸድቋል",
  final_approval: "የመጨረሻ ማረጋገጫ",
  published: "ተሰርቷል",
  broadcasted: "ስክሽት ተደርጓል",
  forwarded_to_coordinator: "ወደ አስተባባሪ ተልኳል",
  forwarded_to_director: "ወደ ዳይሬክተር ተልኳል",
  additional_info_submitted: "ተጨማሪ መረጃ ተልኳል",
  additional_info_response_submitted: "የተጨማሪ መረጃ ምላሽ ተልኳል",
  draft_responded: "ለረቂቅ ምላሽ ተልኳል",
  audit_submitted: "የመቆጣጠሪያ ሪፖርት ተልኳል",
  waiting_for_additional_info: "ተጨማሪ መረጃ በመጠበቅ ላይ",
  // Dashboard
  rd_dashboard: "ዳሽቦርድ",
  rd_welcome_back: "እንኳን ደህና መጡ",
  rd_overview: "በሥራ ዝርዝሮችዎ ውስጥ ያሉ ጥያቄዎች አጠቃላይ እይታ።",
  rd_view_all: "ሁሉንም ይመልከቱ",
  rd_load_failed: "ይህን ዝርዝር መጫን አልተቻለም",
  rd_recent: "የቅርብ ጊዜ",
  rd_no_data: "እስካሁን የሚታይ ነገር የለም",
  rd_loading: "በመጫን ላይ...",
  rd_no_modules: "ለእርስዎ ሚና የሥራ ዝርዝሮች የሉም።",
  rd_in_your_list: "በዝርዝርዎ ውስጥ",
  rd_workload_by_module: "የሥራ ጫና በአገልግሎት",
  rd_items: "ጠቅላላ",
  rd_by_status: "በሁኔታ",
  rd_waiting_for_you: "እርምጃዎን የሚጠብቁ",
  rd_nothing_waiting: "እርምጃዎን የሚጠብቅ ነገር የለም።",
  rd_period_all: "ሁሉም ጊዜ",
  rd_today: "ዛሬ",
  rd_this_week: "ይህ ሳምንት",
  rd_this_month: "ይህ ወር",
  rd_select_year: "ዓመት ይምረጡ",
  rd_period_hint: "በተመረጠው ጊዜ ውስጥ የቀረቡ ጥያቄዎችን ይቆጥራል።",
  rd_eval_summary: "የዐቃቤ ሕግ ግምገማ ማጠቃለያ",
  rd_eval_summary_hint: "የዐቃቤ ሕጎችዎ አማካይ የቡድን ግምገማ ውጤት (የሥራ ፍጥነት፣ ጥራት እና ጫና)። በቅንፍ ያለው ቁጥር የግምገማዎች ብዛት ነው።",
  rd_recent_periods: "የቅርብ ጊዜ (3፣ 6 እና 12 ወራት)",
  rd_last_3_months: "ያለፉት 3 ወራት",
  rd_last_6_months: "ያለፉት 6 ወራት",
  rd_last_12_months: "ያለፉት 12 ወራት",
  rd_year_label: "ዓመት {{year}}",
  rd_quarter_n: "{{n}}ኛ ሩብ ዓመት",
  rd_half_n: "{{n}}ኛ ግማሽ ዓመት",
  rd_whole_year: "ሙሉ ዓመት",
  rd_prosecutor: "ዐቃቤ ሕግ",
  rd_team_average: "የቡድን አማካይ",
  rd_no_evaluations: "በዚህ ጊዜ ውስጥ የዐቃቤ ሕጎችዎ ግምገማ የለም።",
  rd_full_report: "ሙሉ ሪፖርት",
  rd_evaluations_count: "{{count}} ግምገማዎች",
  CheckingAccuracyOfSectors: "የዘርፍ መመሪያዎችን ትክክለኛነት ማረጋገጥ",
  RegisteringDirectives: "መመሪያዎችን መመዝገብ",
};

export default am;